import { makeApi } from "@zodios/core";
import { z } from "zod";

import {
  MetaAdsAccountListResponseSchema,
  MetaAdsConnectRequestSchema,
  MetaAdsConnectResponseSchema,
  MetaAdsDatasetListResponseSchema,
  MetaAdsTokenStatusSchema,
} from "../models";

const api = makeApi([
  {
    alias: "connect",
    method: "post",
    path: "/api/v1/meta-ads/connect",
    parameters: [
      {
        type: "Body",
        name: "body",
        schema: MetaAdsConnectRequestSchema,
      },
    ],
    response: MetaAdsConnectResponseSchema,
  },
  {
    alias: "getStatus",
    method: "get",
    path: "/api/v1/meta-ads/status",
    response: MetaAdsTokenStatusSchema,
  },
  {
    alias: "disconnect",
    method: "delete",
    path: "/api/v1/meta-ads/disconnect",
    response: z.union([z.void(), z.literal("")]),
  },
  {
    alias: "listAccounts",
    method: "get",
    path: "/api/v1/meta-ads/accounts",
    response: MetaAdsAccountListResponseSchema,
  },
  {
    alias: "listDatasets",
    method: "get",
    path: "/api/v1/meta-ads/datasets",
    response: MetaAdsDatasetListResponseSchema,
  },
]);

export { api };
